import _ from 'lodash';

import domains from '../containers/Domains';
import contextMakePost from './Context';

const endpoint = domains.fbEndpoint;

export const publishPost = async (data, token) => {
  const parameters = {
    access_token: token,
    is_published: true,
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const schedulePost = async (data, token) => {
  const parameters = {
    access_token: token,
    scheduled_publish_time: data.timestamp,
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getPost = async (postId, token) => {
  const parameters = {
    access_token: token,
    post_id: postId,
    fields: 'is_published,scheduled_publish_time,permalink_url, created_time',
  };

  const query = _.template(`${endpoint}<%= post_id%>?fields=<%= fields%>&access_token=<%= access_token%>`);
  const result = await fetch(query(parameters));
  return result.json();
};



// WEBPACK FOOTER //
// ./src/fbApi/Post.js